import { _ep0, _mw0, command } from "../commandBuilder";
import { GetChurchManager$ } from "../schemas/schemas_0";
export class GetChurchManagerCommand extends command(_ep0, _mw0, "GetChurchManager", GetChurchManager$) {
}
